import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'menu' ];

	toggle() {
		if (this.menuTarget.hasAttribute('data-group-active')) {
			this.menuTarget.removeAttribute('data-group-active');
			document.querySelector('html').classList.remove('overflow-y-hidden')
		} else {
			this.menuTarget.setAttribute('data-group-active', true);
			document.querySelector('html').classList.add('overflow-y-hidden')
		}
	}
}